import axios from "axios";
import {
    GET_FULL_CONFIG_BY_ENTITY_TYPE_URL,
    GET_TEMPLATE_ENTITY_CONFIG_BINDINGS_URL,
    get_request_config
} from "@/utils/system_constants/constant";
import {
    first_non_empty_number,
    normalize_binding_record,
    parse_response_data
} from "./esigning_setup_helpers";

function has_failed_response(parsed_response) {
    const did_fail = parsed_response?.status && parsed_response.status !== "success";
    return did_fail;
}

function build_template_bindings_result(entity_config_id, template_bindings = [], selected_template = null, template_bindings_error = "") {
    const result = {
        entity_config_id,
        template_bindings,
        selected_template,
        template_bindings_error
    };
    return result;
}

function get_selected_template(vm, template_bindings) {
    const selected_template_binding_id = Number(vm.selected_template?.binding_id || 0);
    const selected_template_entity_type_id = Number(vm.selected_template?.template_document_entity_type_id || 0);

    const selected_template = template_bindings.find((binding) => (
        Number(binding?.binding_id) === selected_template_binding_id
        || Number(binding?.template_document_entity_type_id) === selected_template_entity_type_id
    )) || null;
    const resolved_template = selected_template;
    return resolved_template;
}

function resolve_route_entity_config_id(vm) {
    return first_non_empty_number(
        vm.$route?.query?.entityConfigId,
        vm.$route?.query?.entity_config_id,
        vm.$route?.params?.entityConfigId,
        vm.$route?.params?.entity_config_id
    );
}

async function fetch_entity_config_id_by_entity_type(route_entity_type_id) {
    const response = await axios.get(
        GET_FULL_CONFIG_BY_ENTITY_TYPE_URL,
        get_request_config({
            params: {
                entity_type_id: route_entity_type_id
            }
        })
    );
    const parsed_response = parse_response_data(response.data);
    const resolved_id = Number(parsed_response?.data?.entity_config?.id || 0);
    const entity_config_id = Number.isFinite(resolved_id) && resolved_id > 0 ? resolved_id : null;
    return entity_config_id;
}

export async function resolve_entity_config_id(vm) {
    const route_config_id = resolve_route_entity_config_id(vm);
    if (route_config_id) {
        const resolved_route_config_id = route_config_id;
        return resolved_route_config_id;
    }

    const route_entity_type_id = vm.route_entity_type_id;
    if (!route_entity_type_id) {
        const empty_entity_config_id = null;
        return empty_entity_config_id;
    }

    const fetched_entity_config_id = fetch_entity_config_id_by_entity_type(route_entity_type_id);
    return fetched_entity_config_id;
}

function build_missing_entity_config_result(entity_config_id) {
    const missing_entity_config_result = build_template_bindings_result(
        entity_config_id,
        [],
        null,
        "No entity configuration was provided for this signing flow."
    );
    return missing_entity_config_result;
}

function get_binding_records(parsed_response) {
    const binding_records = Array.isArray(parsed_response?.data) ? parsed_response.data : [];
    return binding_records;
}

function get_active_template_bindings(parsed_response) {
    const active_template_bindings = get_binding_records(parsed_response)
        .filter(function filter_active_bindings(binding) {
            return binding?.is_active !== false;
        })
        .map(function map_binding(binding) {
            return normalize_binding_record(binding);
        });
    return active_template_bindings;
}

export async function fetch_template_bindings(vm) {
    const entity_config_id = await resolve_entity_config_id(vm);
    if (!entity_config_id) {
        const missing_entity_config_result = build_missing_entity_config_result(entity_config_id);
        return missing_entity_config_result;
    }

    const response = await axios.get(
        GET_TEMPLATE_ENTITY_CONFIG_BINDINGS_URL,
        get_request_config({
            params: { entity_config_id }
        })
    );
    const parsed_response = parse_response_data(response.data);
    if (has_failed_response(parsed_response)) {
        const error_message = parsed_response?.message || "Failed to load template bindings.";
        vm.show_error(error_message);
        const bindings_error_result = build_template_bindings_result(entity_config_id, [], null, error_message);
        return bindings_error_result;
    }

    const template_bindings = get_active_template_bindings(parsed_response);
    const template_bindings_result = build_template_bindings_result(
        entity_config_id,
        template_bindings,
        get_selected_template(vm, template_bindings),
        ""
    );
    return template_bindings_result;
}
